// import { getFetchMock } from './mocks/fetch';
import { AgencyAddData, AgencyUpdateData } from '@libs/models/agencies';
import { request } from '../request';

export async function activateAgency(id: string): Promise<void> {
  const response = await request.post(`/agencies/activate/${id}`);
}

export async function deactivateAgency(id: string): Promise<void> {
  const response = await request.post(`/agencies/activate/${id}`);
}

export async function addAgency(entity: AgencyAddData): Promise<string> {
  const response = await request.post<string>(`/agencies`, {
    ...entity,
    agencyName: entity.name,
    address: {
      addressLine1: entity.address.addressFirst,
      addressLine2: entity.address.addressSecond,
      city: entity.address.city,
      state: entity.address.state,
      zipCode: entity.address.zipCode,
    },
  } as ServerAgencyAddData);
  return response.data;
}

export async function updateAgency(id: string, entity: AgencyUpdateData): Promise<void> {
  const response = await request.post(`/agencies/${id}`, {
    ...entity,
    agencyName: entity.name,
    address: {
      addressLine1: entity.address.addressFirst,
      addressLine2: entity.address.addressSecond,
      city: entity.address.city,
      state: entity.address.state,
      zipCode: entity.address.zipCode,
    },
  } as ServerAgencyAddData);
}

type ServerAgencyAddData = {
  agencyName: string;
  domainName: string;
  agencyType: string;
  linesOfBusiness: string[];
  qualifications: string[];
  contact: {
    email: string;
    firstName: string;
    phoneNumber: string;
    lastName: string;
  };
  address: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
  };
};
